import { PropsWithChildren, ReactNode } from "react";
import { useAuth } from "../features/auth/useAuth";
import { UserRole } from "../features/auth/types";

interface RoleGuardProps extends PropsWithChildren {
  allow: UserRole[];
  fallback?: ReactNode;
}

const RoleGuard = ({ allow, fallback = null, children }: RoleGuardProps) => {
  const { user } = useAuth();

  if (!user) {
    return fallback;
  }

  return allow.includes(user.role) ? <>{children}</> : fallback;
};

export default RoleGuard;
